import api from './api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface WalletAuthRequest {
  walletAddress: string;
  signature: string;
  message: string;
}

export interface AuthResponse {
  accessToken: string;
}

class AuthService {
  /**
   * Login with email and password
   */
  async loginWithEmail(email: string, password: string): Promise<string> {
    try {
      const response = await api.post<AuthResponse>('/auth/login', {
        email,
        password,
      });
      return response.data.accessToken;
    } catch (error: any) {
      console.error('Login error:', error);
      throw new Error(error.message || 'Login failed');
    }
  }

  /**
   * Login with Phantom wallet signature
   */
  async loginWithWallet(
    walletAddress: string,
    signature: string,
    message: string
  ): Promise<string> {
    try {
      const response = await api.post<AuthResponse>('/auth/wallet', {
        walletAddress,
        signature,
        message,
      });
      return response.data.accessToken;
    } catch (error: any) {
      console.error('Wallet login error:', error);
      throw new Error(error.message || 'Wallet authentication failed');
    }
  }

  /**
   * Logout - removes token from storage
   */
  logout(): void {
    localStorage.removeItem('authToken');
  }

  /**
   * Get current auth token
   */
  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  /**
   * Generate authentication message for wallet signing
   */
  generateAuthMessage(walletAddress: string): string {
    const timestamp = new Date().getTime();
    return `Sign this message to authenticate with FlipScout.\n\nWallet: ${walletAddress}\nTimestamp: ${timestamp}`;
  }
}

export const authService = new AuthService();
export default authService;
